import { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { useActionData } from 'react-router';

import Button from 'client/components/GDS/Button/Button';
import SnackBar from 'client/components/ui/Snackbar/SnackBar';
import NavLink from 'client/components/aria/NavLink/NavLink';

import { BOOKMARKS_PAGE } from 'client/utils/routes/routeConstants';

import Icon from '@mdi/react';
import { mdiClose } from '@mdi/js';

import styles from '../button.module.scss';

const BookmarkSnackBar = () => {
    const { createdBookmark } = useActionData() || {};
    const intl = useIntl();

    const [open, setOpen] = useState(false);

    useEffect(() => {
        setOpen(Boolean(createdBookmark));
    }, [createdBookmark]);

    const closeButton = <Button
        aria-label={intl.formatMessage({ id: 'close' })}
        data-testid="bookmarkSnackBar.close"
        variant="transparent"
        className={styles.button}
        onClick={() => setOpen(false)}
    >
        <Icon path={mdiClose} size={1}/>
    </Button>;

    return (
        open
            ? <SnackBar variant="success" endOfLine={closeButton}>
                <FormattedMessage
                    id={'bookmark.save.success.alert'}
                    values={{
                        b: chunks => <div><b>{chunks}</b><br/></div>,
                        link: chunks => <NavLink inverse={true} rel="noreferrer" to={BOOKMARKS_PAGE}>{chunks}</NavLink>
                    }}
                />
            </SnackBar>
            : null
    );
};

export default BookmarkSnackBar;
